export default "__VITE_ASSET__BDF2pos3__"